// Status.js

import React, { useEffect, useRef, useState } from "react";
import { ActivityIndicator, Animated, Text, View } from "react-native";
import { Feather } from "@react-native-vector-icons/feather";  // https://feathericons.com/?query=


const DisplayStatus = ({textState, setTextState, style={}, textStyle={}, iconStyle={}, timeout=3000, autoHide=true, ...props}) => {
  const _to = useRef(null);
  useEffect(()=>{
    // Unload - This prevents a react error from being thrown if this component us 'unloaded' before the timeout completes because the expected target no longer exists.
    return ()=>{
      if (_to.current !== null) {
        window.clearTimeout(_to.current);
        _to.current = null;
      };
    };
  },[_to]);
  if (!setTextState) {
    [textState, setTextState] = useState(textState);
  }
  let showCheckIcon = false;
  const txtLC = textState.toLowerCase();
  const isErrorTypeText = (
       txtLC.includes("please")
    || txtLC.includes("require")
    || txtLC.includes("error")
    || txtLC.includes("oops")
    || txtLC.includes("already")
    || txtLC.includes("not")
    || txtLC.includes("exist")
    || txtLC.includes("invalid")
    || txtLC.includes("failed")
    || txtLC.includes("wrong")
    || txtLC.includes("missing")
    || txtLC.includes("incomplete")
  );
  if (!!textState && !textState.includes("...")) {
    if (!isErrorTypeText) {
      showCheckIcon = true;
    }
    if (!!_to.current) {
      window.clearTimeout(_to.current);
      _to.current = null;
    }
    if (!!autoHide) {
      _to.current = window.setTimeout(()=>{ try { setTextState(""); window.clearTimeout(_to.current); _to.current = null; } catch(e) {/*silent fail*/} },timeout);
    }
  }
  const _color = (!!isErrorTypeText ? window.main.theme.colors.caution : (textState.includes("...") ? window.main.theme.colors.auxiliary : window.main.theme.colors.success));
  return (
    <>
      {textState &&
        <View style={{...window.main.theme.inlineSubmitStatus,paddingHorizontal:0,position:"absolute",alignItems:"flex-start",flexGrow:1,paddingTop:5,...style}} {...props}>
          <Text style={{color:_color,flexWrap:"wrap",textAlign:"center",...textStyle}} numberOfLines={1}>
            {showCheckIcon &&
              <Feather name={"check-circle"} size={window.main.theme.sizes.icon.default-2} style={{fontSize:"inherit",...iconStyle,marginRight:8}} />
            }
            {typeof(textState)==="string" && textState}
            {typeof(textState)==="object" && <textState />}
          </Text>
        </View>
      }
    </>
  );
};


const ScreenLoading = ({loadingState,fadeValue=0.75,style={}}) => {
  const _to = useRef(null);
  useEffect(()=>{
    // Unload - This prevents a react error from being thrown if this component us 'unloaded' before the timeout completes because the expected target no longer exists.
    return ()=>{
      if (_to.current !== null) {
        window.clearTimeout(_to.current);
        _to.current = null;
      };
    };
  },[_to]);
  const [isShowing, setIsShowing] = useState(loadingState);
  const fadeAnim = useRef(new Animated.Value(1)).current;
  const setLoading = () => {
    setIsShowing(true);
    Animated.timing(fadeAnim, { toValue:fadeValue, duration:1, useNativeDriver:(window.main.platform_os!=="web") }).start();
  };
  const fadeLoading = (time=500) => {
    Animated.timing(fadeAnim, { toValue:0, duration:time, useNativeDriver:(window.main.platform_os!=="web") }).start();
    _to.current = window.setTimeout(()=>{ setIsShowing(false); },time);
  };
  useEffect(()=>{
    if (!isShowing && !!loadingState) {
      setLoading();
    } else if (!!isShowing && !loadingState) {
      fadeLoading();
    }
  },[isShowing,loadingState]);
  return (
    <>
      {!!isShowing &&
        <Animated.View style={{ backgroundColor:window.main.theme.colors.mode.containerBackgroundColor, flexDirection:"column", justifyContent:"flex-start", opacity:1, position:"absolute", bottom:0, left:0, right:0, top:0, transition:"opacity 0ms", opacity:fadeAnim, paddingTop:50, zIndex:9999999, ...style}}>
          <ActivityIndicator color="green" size="large" />
        </Animated.View>
      }
    </>
  );
};


export {
  DisplayStatus,
  ScreenLoading,
};
